import * as ngCore from '@angular/core'

@ngCore.Component({
  selector: 'atn-ds-widget',
  standalone: true,
  styleUrls: ['./widget.component.scss'],
  templateUrl: './widget.component.html',
})
export class AtnDsWidgetComponent {
  /**
   * Represents title in widget header.
   */
  @ngCore.Input()
  public title: string | undefined
}
